import { render, staticRenderFns } from "./EstoqueOutrasMovimentacoes.vue?vue&type=template&id=c5aa16e8&"
import script from "./EstoqueOutrasMovimentacoes.vue?vue&type=script&lang=js&"
export * from "./EstoqueOutrasMovimentacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports